import * as React from 'react';

import { Heading4, SkeletonGroup } from '@cian/ui-kit';
import { useInView } from '@cian/valuation-utils-component';

import * as styles from './RecommendationsList.css';
import { useVisitedOffersContext } from '@cian/frontend-visited-offers-widget';

export interface IRecommendationsList {
  onShow?(): void;
  children: React.ReactNode;
}

export const RecommendationsList: React.FC<IRecommendationsList> = ({ onShow, children }) => {
  const [isShown, setIsShown] = React.useState(false);
  const { isLoaded: isVisitedOffersLoaded } = useVisitedOffersContext();

  const { ref, inView } = useInView({
    threshold: 0,
    triggerOnce: true,
  });

  React.useEffect(() => {
    if (inView && onShow && !isShown && isVisitedOffersLoaded) {
      onShow();
      setIsShown(true);
    }
  }, [inView, onShow, isShown, isVisitedOffersLoaded]);

  return (
    <div ref={ref} className={styles['container']}>
      <Heading4 textAlign="center">Могут подойти</Heading4>
      <SkeletonGroup scope="page" cols={2} gap={[16, 8]}>
        {children}
      </SkeletonGroup>
    </div>
  );
};
